import { cn } from '@app/utils/cn';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { Dropdown as DropdownNs } from '@typings';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Dropdown, DropdownMenu, DropdownTrigger } from '../Dropdown';
import { Drag } from '../Icons';

interface Props {
  label: string;
  isDragging?: boolean;
  listeners?: SyntheticListenerMap;
  menuItems?: DropdownNs.MenuItem[];
}

export const SortableItemHandle = React.forwardRef<HTMLButtonElement, Props>(({ label, isDragging = false, listeners, menuItems }, ref) => {
  const { t } = useTranslation(['accessibilityDescriptions']);

  const title = t('accessibilityDescriptions:reorder_item', { item: label });

  return (
    <Dropdown title={title}>
      <DropdownTrigger>
        <button
          ref={ref}
          type="button"
          disabled={!isDefined(menuItems) || isEmpty(menuItems)}
          aria-label={title}
          draggable
          className={cn('-m-1 flex h-6 w-6 shrink-0 cursor-grab items-center justify-center rounded-full', {
            '!outline-none': isDragging,
          })}
          {...listeners}
        >
          <Drag className="size-4 text-neutral-60" />
        </button>
      </DropdownTrigger>
      <DropdownMenu items={menuItems ?? []} />
    </Dropdown>
  );
});
